export default __webpack_public_path__ + "static/media/SchipholKlein.f28116f5.jpg";